window.onFirstUserInteraction = null;

jQuery(window).on('load', function() {
    let lazyLoaded = false;

    jQuery(document).one('click keydown keyup mousemove touchstart mousewheel', function() {
        if (!lazyLoaded) {
            if (typeof window.onFirstUserInteraction === 'function') {
                window.onFirstUserInteraction();
            }

            lazyLoaded = true;
        }        
    });
});


// WEBPACK FOOTER //
// ./scripts/util/hooks.js